import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=1b893c4a&scoped=true"
var script = {}
import style0 from "./Snackbar.vue?vue&type=style&index=0&id=1b893c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b893c4a",
  null
  
)

export default component.exports